<template>
    <div class="odgovor-single" @click="select" v-bind:class="{'odgovor-single': true, 'answer-disabled': !this.canClick, 'active': this.answer.index == value}">
        <div class="checkbox" v-bind:class="{'checkbox': true, 'active': this.answer.index == value}"></div>
        <div class="odgovor img-odgovor" v-if="answer.imgValue">
            <img :src="answer.imgValue"/>
        </div>
        <div class="odgovor" v-else-if="answer.value">
            <p v-html="answer.value"></p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'odgovor-single',
    props: ['answer', 'value', 'canClick'],
    data: function () {
        return {

        }
    },
    methods: {
        select () {
            if (this.canClick) {
                this.$emit('input', this.answer.index)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.odgovor-single {
    clear: both;
    position: relative;
    width: 100%;
    cursor: pointer;
    &.active p {
        color: #3d85ce;
    }
    p {
        position: relative;
        padding-left: 30px;
        transition: color .4s ease-in-out;
        margin-bottom: 16px;
    }
    .checkbox {
        position: absolute;
        top: 0;
        left: 0;
        width: 21px;
        height: 21px;
        background-image: url(~@/assets/img/icons/checkbox.png);
        background-position: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        // float: left;
        margin-right: 5px;
        &.active {
            background-image: url(~@/assets/img/icons/checkbox-checked.png);
        }
    }
    &.answer-disabled {
        color: #999;
    }
    .img-odgovor {
        padding-left: 30px;
        padding-bottom: 20px;
    }
}
</style>
